var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-table',{attrs:{"items":_vm.items,"fields":_vm.fields,"small":"","responsive":""},scopedSlots:_vm._u([{key:"cell(loadedBy)",fn:function(){return [(_vm.info.loadedBy.name)?_c('span',[_c('div',[_vm._v(_vm._s(_vm.info.loadedBy.name))]),_c('div',[_c('phone-number',{attrs:{"phoneNumber":_vm.info.loadedBy.phone}})],1)]):_vm._e()]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }